module.exports = __webpack_public_path__ + "img/hand-bg-edit.2f29109b.png";